// extracted by mini-css-extract-plugin
export default {"container":"CreateSituation_container__RBrg1","nodeTypes":"CreateSituation_nodeTypes__IPr6A"};